import {useQuery} from "@tanstack/react-query";
import registrationReviewService from "../services/registration-review-service";
import {BreederService} from "../services/breeder-service";

export const usePendingRegistrationRequests = () => useQuery({
    queryKey: ['pending-registrations-requests'],
    queryFn: async () => {
        const {id: breederId} = await BreederService.info();
        return await registrationReviewService.loadPendingRequestsOfBreeder(breederId);
    },
});

